import { BrowserModule } from '@angular/platform-browser';
import { APP_ID, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { PushNotificationsService } from './services/push-notifications.service';
import { environment } from '../environments/environment';

// Feature Modules
import { SharedModule } from './components/shared/shared.module';
import { AdministrationModule } from './components/modules/administration/administration.module';
import { MaintenanceModule } from './components/modules/maintenance/maintenance.module';
import { FuelModule } from './components/modules/fuel/fuel.module';
import { InventoryModule } from './components/modules/inventory/inventory.module';
import { HumanResourcesModule } from './components/modules/human-resources/human-resources.module';
import { IndicatorsModule } from './components/modules/indicators/indicators.module';
import { InspectionsModule } from './components/modules/inspections/inspections.module';
import { LocalizationModule } from './components/modules/localization/localization.module';
import { NotificationsModule } from './components/modules/notifications/notifications.module';
import { RentalModule } from './components/modules/rental/rental.module';
import { RootModule } from './components/modules/root/root.module';
import { PagesModule } from './modules/pages.module';

import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeEs);

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        // Feature Modules
        SharedModule,
        MaintenanceModule,
        AdministrationModule,
        FuelModule,
        InventoryModule,
        HumanResourcesModule,
        IndicatorsModule,
        InspectionsModule,
        LocalizationModule,
        NotificationsModule,
        RentalModule,
        RootModule,
        PagesModule,
        // Service Worker
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        provideZoneChangeDetection(),
        PushNotificationsService,
        { provide: APP_ID, useValue: 'fosil-app' },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
